import postAPI from './postAPI.js'

export default async function postReorderStepFields(taskFlowStepId, fieldIds) {
    const data = await postAPI('admin/taskflows/steps/fields/reorder', {
        task_flow_step_id: taskFlowStepId,
        field_ids: fieldIds
    });
    return data;
}
